export const SpecialtyFilter = {
  flow: 'x',
  gap: 'Y',
  flexWrap: 'wrap',
  align: 'center flex-start',

  state: {
    specialties: [
      { key: 'all', label: '{{ all | polyglot }}', count: 5 },
      { key: 'orthodontics', label: '{{ orthodontics | polyglot }}', count: 0 },
      { key: 'endodontics', label: '{{ endodontics | polyglot }}', count: 1 },
      { key: 'periodontics', label: '{{ periodontics | polyglot }}', count: 2 },
      { key: 'surgery', label: '{{ surgery | polyglot }}', count: 0 },
      { key: 'general', label: '{{ general | polyglot }}', count: 1 },
      { key: 'prosthetics', label: '{{ prosthetics | polyglot }}', count: 1 }
    ]
  },

  children: (el, s) => {
    var specs = s.specialties || []
    return specs.map(function (spec) {
      return {
        filterKey: spec.key,
        filterLabel: spec.label,
        filterCount: spec.count
      }
    })
  },
  childrenAs: 'state',
  childExtends: 'SpecialtyPill'
}

export const SpecialtyPill = {
  flow: 'x',
  gap: 'X',
  align: 'center center',
  padding: 'Y A',
  round: 'C',
  cursor: 'pointer',
  fontSize: 'Z',
  fontWeight: '600',
  transition: 'background 0.15s, color 0.15s',
  background: (el, s) => {
    var active = s.root.noteSpecialtyFilter || 'all'
    return s.filterKey === active ? 'teal' : 'inkSurface'
  },
  color: (el, s) => {
    var active = s.root.noteSpecialtyFilter || 'all'
    return s.filterKey === active ? 'inkText' : 'inkMuted'
  },
  ':hover': { opacity: '0.85' },

  PillLabel: {
    text: (el, s) => s.filterLabel || ''
  },

  PillCount: {
    tag: 'span',
    text: (el, s) => s.filterCount !== undefined ? String(s.filterCount) : '0',
    fontSize: 'X',
    fontWeight: '700',
    padding: 'X Y',
    round: 'C',
    minWidth: 'Z',
    textAlign: 'center',
    background: (el, s) => {
      var active = s.root.noteSpecialtyFilter || 'all'
      return s.filterKey === active ? 'teal.3' : 'inkBorder'
    },
    color: (el, s) => {
      var active = s.root.noteSpecialtyFilter || 'all'
      return s.filterKey === active ? 'inkText' : 'inkMuted'
    }
  },

  onClick: (el, s) => {
    s.root.update({ noteSpecialtyFilter: s.filterKey })
  }
}
